import API from "../../../store/api";
import { setNotifications } from '../../../store/actions/notificationActions';
import { clearMessage, setMessage } from '../../../store/actions/dialogActions';
import { setAzure, clearAzure } from '../../../store/actions/azureActions';
import { authLogout } from '../../../store/actions/authActions';

export const searchUsers = (bearerAuth, displayName) => {
  return async dispatch => {

    API.get(`/api/portal/azure/search?${displayName ? 'displayName=' + displayName : ''}`)
      .set('Authorization', `Bearer ${bearerAuth}`)
      .ok(res => res.status < 500) // anything under 500 handled in code, 500+ thrown as exception
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          dispatch(setAzure(response.body))
        } else if (response.status === 401) {
          dispatch(clearAzure);
          dispatch(authLogout);
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
            if (message.includes(',')) { //Password error, make it more presentable
              let messageArray = message.split(',');
              message = <>{messageArray.map((val) => <div>{val}</div>)}</>
            }
          } 
        }
        dispatch(setMessage({
          title: 'Failed to Pull SSO Users',
          message: message,
          type: 'ERR',
        }))
      })
  }
}